
import { Component, Vue } from "vue-property-decorator";
import Axios from 'axios';

@Component
export default class LinkSns extends Vue {
  joinTypes: Array<string> = [];
  isLoad = false;
  isLinkedKakao = false;
  isLinkedNaver = false;
  isLinkedApple = false;

  isLink;

  // 카카오, 애플 연동
  runWith(provider: string): void {
    switch(provider) {
      case 'kakao':
        this.isLink = !this.isLinkedKakao;
        break;
      case 'naver':
        this.isLink = !this.isLinkedNaver;
        break;
      case 'apple':
        this.isLink = !this.isLinkedApple;
        break;
      default:
        break;
    }

    if(this.isLink) {
      // {0} 계정과 연동하시겠습니까?
      if(confirm(this.$t('member-info.c0003', [this.getProviderName(provider)]).toString()) == false) {
        return;
      }
    } else {
      // {0} 계정과 연결을 해제하시겠습니까?
      if(confirm(this.$t('member-info.c0004', [this.getProviderName(provider)]).toString()) == false) {
        return;
      }
    }
    
    const userAgent = navigator.userAgent.toLowerCase();
    if(window['ReactNativeWebView'] && userAgent.indexOf('iphone') > -1 && provider == 'apple'){
      window["webViewBridge"].send("appleLogin", {}, this.callbackAppleLink);
    }else{
      const url = process.env.VUE_APP_BASE_URL_API + `/oauth2/authorization/${provider}`;
      location.href = url;
    }
  }

  //애플 앱 로그인 인증 콜백
  callbackAppleLink(result: any): void {
    Axios.post('/link-sns/app', {appleUser: result}).then(r=>{
      if(r.data.responseCode) {
        alert(this.$t(r.data.responseCode));
        return;
      }
      // "a0005": "연동되었습니다."
      alert(this.$t('sns-link.a0005'));
      window.location.reload();
    });
  }

  // 애플앱 연동해제
  unlinkSnsForApple(provider: string): void {
    // SNS계정 연동을 해제 하시겠습니까?
    if(confirm(this.$t('sns-link.c0001').toString()) == false) {
      return;
    }
    Axios.post(`/unlink-sns/${provider}/app`)
    .then((r)=>{
      if(r.data) {
        // 입력하신 아이디와 계정 연동이 해제 되었습니다.
        alert(this.$t('join.a0027'));
        this.setJoinTypesFlag(provider);
      } else {
        Axios.get('/login/ping')
        .then(r=>{
          if(r.data as string == 'pong') {
            // 인증토큰이 유효하지 않습니다. 애플로 다시 로그인 후 연결해제를 해주세요.
            alert(this.$t('sns-link.a0003'));
          } else {
            // 아이디와 연동되지 않아 로그아웃 됩니다.
            alert(this.$t('sns-link.a0004'));
            this.$router.push({name: 'Main'})
          }
        })
      }
    });
  }

  // 연동해제
  unlinkSns(provider: string): void {
    // SNS계정 연동을 해제 하시겠습니까?
    if(confirm(this.$t('sns-link.c0001').toString()) == false) {
      return;
    }

    Axios.post(`/unlink-sns/${provider}`)
    .then((r)=>{
      if(r.data) {
        // 입력하신 아이디와 계정 연동이 해제 되었습니다.
        alert(this.$t('join.a0027'));
        this.setJoinTypesFlag(provider);
      } else {
        // 애플은 아이디 연동이 없어 해제할 경우 로그아웃 처리함
        // 단, 아이디 가입 후 애플 연동한 계정의 경우 로그아웃 처리 안함
        Axios.get('/login/ping')
        .then(r=>{
          if(r.data as string == 'pong') {
            if(provider == 'naver') {
              // 인증토큰이 유효하지 않습니다. 네이버아이디로 재로그인 후 연결해제를 해주세요.
              alert(this.$t('sns-link.a0001'));
            } else if(provider == 'apple') {
              // 인증토큰이 유효하지 않습니다. 애플로 다시 로그인 후 연결해제를 해주세요.
              alert(this.$t('sns-link.a0003'));
            }
          } else {
            // 아이디와 연동되지 않아 로그아웃 됩니다.
            alert(this.$t('sns-link.a0004'));
            this.$router.push({name: 'Main'})
          }
        })
      }
    });
  }

  getProviderName(provider: string): string {
    switch(provider) {
      case 'kakao':
        return '카카오';
      case 'naver':
        return '네이버';
      case 'apple':
        return '애플';
      default:
        return '';
    }
  }

  // 가입 유형에 따라 플레그 값 변경
  setJoinTypesFlag(joinType: string) {
    switch(joinType) {
      case 'kakao':
      case '12':
        this.isLinkedKakao = !this.isLinkedKakao;
        break;
      case 'naver':
      case '13':
        this.isLinkedNaver = !this.isLinkedNaver;
        break;
      case 'apple':
      case '14':
        this.isLinkedApple = !this.isLinkedApple;
        break;
    }
  }

  created(): void {
    // 이미 다른 아이디와 연동되어 있습니다.
    this.$route.query.message && alert(this.$t(this.$route.query.message as string));

    Axios.get('/mypage/link-sns/join-types')
    .then(r=>{
      this.joinTypes = r.data;
      this.joinTypes.forEach(item => {
        this.setJoinTypesFlag(item);
      })
      this.isLoad = true;
    })
  }
}
